import { setCookie, getCookie } from "./functions.js";

$(document).ready(function () {
  const compareBkIds = [];
  $(".top-rating__input, .bk-card__checkbox").on("change", function () {
    const count = $(
      ".top-rating__input:checked, .bk-card__checkbox:checked"
    ).length;

    $(".top-rating__input, .bk-card__checkbox").each(function () {
      const bkId = $(this).val();
      // если выбран, записываем id БК в массив
      if ($(this).is(":checked")) {
        // проверяем, что значения ещё нет в массиве
        const index = compareBkIds.indexOf(bkId);
        if (index == -1) {
          compareBkIds.push(bkId);
        }
      } else {
        // если нет, то удаляем
        const index = compareBkIds.indexOf(bkId);
        if (index > -1) {
          compareBkIds.splice(index, 1);
        }
      }
    });

    // скрываем попап, если нет выбранных элементов
    if (!compareBkIds.length) {
      $("#comparePopup").slideUp(150);
    } else {
      // если попап скрыт и выбраны элементы - показываем его
      if (!$("#comparePopup").is(":visible")) {
        $("#comparePopup").slideDown(150);
      }
    }

    // если выбранных БК больше трёх, убираем выделение с первого
    if (count > 3) {
      const firstBkId = compareBkIds[0];
      $("#compare-" + firstBkId).prop("checked", false);
      compareBkIds.shift();
    }

    // записываем массив в куки
    const json_str = JSON.stringify(compareBkIds);
    setCookie("compareBkIds", json_str);

    // меняем цифру выбранных БК в попапе
    $(".compare-popup__count").text(compareBkIds.length);

    // обновляем список БК
    $.ajax({
      method: "POST",
      url: "/ajax/loadcomparebkpopup",
      data: { compareBkIds: json_str },
    }).done(function (res) {
      $(".compare-popup__list").html(res);
    });
  });

  // очищаем выбранные БК для сравнения
  $("#clearCompare").click(function (evt) {
    evt.preventDefault();

    $("#comparePopup").slideUp(150);

    compareBkIds.length = 0;
    setCookie("compareBkIds", compareBkIds);

    $(".top-rating__input:checked, .bk-card__checkbox:checked").each(
      function () {
        $(this).prop("checked", false);
      }
    );
  });

  // открывает селект
  function openCompareSelect(select) {
    select.addClass("compare-detail__select--open");
    select.slideDown(150);
  }

  function closeCompareSelect(select) {
    $(".compare-detail__select--open").slideUp(150);
    $(".compare-detail__select--open").removeClass(
      "compare-detail__select--open"
    );
  }

  // добавить БК для сравнения
  $(document).on("click", ".compare-detail__add", function (evt) {
    evt.preventDefault();

    // открыть селект
    const compareDetailTtem = $(this).parents(".compare-detail__item");
    const compareDetailSelect = compareDetailTtem.find(
      ".compare-detail__select"
    );
    openCompareSelect(compareDetailSelect);
  });

  // закрываем селект по клику вне
  $(document).mouseup(function (evt) {
    const compareDetailSelect = $(".compare-detail__select--open");
    if (
      !compareDetailSelect.is(evt.target) &&
      compareDetailSelect.has(evt.target).length === 0
    ) {
      closeCompareSelect();
    }
  });

  // закрываем селект по нажатию клавиши ESC
  $(document).on("keyup", function (evt) {
    if (evt.key == "Escape" && $(".compare-detail__select--open").length) {
      closeCompareSelect();
    }
  });

  // выбираем БК в селекте
  $(document).on("click", ".compare-detail__option", function () {
    const bkId = $(this).data("bk-id").toString();
    const compareDetailSelect = $(this).parents(".compare-detail__select");
    const order = $(".compare-detail__select").index(compareDetailSelect);
    // добавляем id БК в куки
    let compareBkIdsArr;
    if (getCookie("compareBkIds")) {
      const compareBkIds = getCookie("compareBkIds");
      compareBkIdsArr = JSON.parse(compareBkIds);
    } else {
      compareBkIdsArr = [];
    }

    compareBkIdsArr[order] = bkId;
    const json_str = JSON.stringify(compareBkIdsArr);
    setCookie("compareBkIds", json_str);

    updateSelectValues();
    updateProps();

    // выводим БК в итемах
    const compareDetailItem = $(this).parents(".compare-detail__item");

    $.ajax({
      method: "POST",
      url: "/ajax/loadcomparebk",
      data: { bkId: bkId, order: order },
    }).done(function (res) {
      compareDetailItem.html(res);
    });
  });

  // очистить БК
  $(document).on("click", ".compare-detail__clean", function (evt) {
    evt.preventDefault();

    const compareDetailContent = $(this).parents(".compare-detail__content");
    compareDetailContent.remove();

    // удаляем id из куки
    const bkId = $(this).data("bk-id").toString();
    const compareBkIds = getCookie("compareBkIds");
    const compareBkIdsArr = JSON.parse(compareBkIds);
    const index = compareBkIdsArr.indexOf(bkId);

    if (index > -1) {
      compareBkIdsArr[index] = "";
      //compareBkIdsArr.splice(index, 1);
    }

    const json_str = JSON.stringify(compareBkIdsArr);
    setCookie("compareBkIds", json_str);
    updateSelectValues();
    updateProps();
  });

  // обновляет значения селектов
  function updateSelectValues() {
    $.ajax({
      method: "POST",
      url: "/ajax/updateselectvalues",
    }).done(function (res) {
      $(".compare-detail__list").each(function () {
        $(this).html(res);
      });
    });
  }

  // обновляет свойства БК
  function updateProps(order) {
    $.ajax({
      method: "POST",
      url: "/ajax/updateprops",
    }).done(function (res) {
      $(".compare-detail__info").html(res);
    });
  }
});
